import { IUser } from "../../user/IUser";
import { isPremium } from "../../utils";
import { IMenuItem } from "../IMenu";
import { ddPro } from "./en";

export const freeTrial: IMenuItem = {
  label: "Prueba gratis",
  href: "/es/nuevo-miembro"
};

export const becomeMemberPayment: IMenuItem = {
  label: "Prueba gratis",
  href: "/es/hazte-miembro/payment"
};

export const login: IMenuItem = {
  label: "Inicio de sesión",
  href: "/es/iniciar-sesion"
};

export const logout: IMenuItem = {
  label: "Cerrar sesión"
};

export const shoppingList: IMenuItem = {
  label: "Lista de compras",
  href: "/es/lista-compras"
};

export const tracking: IMenuItem = {
  label: "Mi seguimiento",
  href: "/es/seguimiento"
};

export const appCta: IMenuItem = {
  label: "Diet Doctor Eat app"
};

export const stores: IMenuItem[] = [
  {
    label: "App Store",
    href: "https://apps.apple.com/es/app/diet-doctor-eat/id1440002708"
  },
  {
    label: "Play Store",
    href: "https://play.google.com/store/apps/details?id=com.dietdoctor.EatApp&hl=es"
  }
];

export const myAccount: IMenuItem = {
  label: "Mi cuenta",
  children: [
    {
      label: "Mi configuración personal",
      href: "/es/usuario/ajustes"
    },
    {
      label: "Mis preferencias de comida",
      href: "/es/usuario/preferencias-comida"
    },
    {
      label: "Mis favoritos",
      href: "/es/miembro/mis-favoritos",
      onlyPremium: true
    },
    {
      label: "Mis menús",
      href: "/es/low-carb/menus/mi-planificador",
      onlyPremium: true
    },
    {
      label: "Mi lista de compras",
      href: "/es/lista-compras",
      onlyPremium: true
    },
    {
      label: "Mi seguimiento",
      href: "/es/seguimiento",
      onlyPremium: true
    },
    {
      label: "Mi membresía",
      href: "/es/mi-cuenta"
    },
    {
      label: "Mis preferencias de comunicación",
      href: "/es/braze/preference-center",
    },
    {
      label: "Mis beneficios",
      href: "/es/explora-dd-plus"
    },
    {
      label: "Centro de ayuda",
      href: "https://dietdoctor.zendesk.com/hc/es"
    }
  ]
};

export const all: IMenuItem[] = [
  { ...ddPro },
  {
    label: "Menu",
    children: [
      {
        label: "Dietas",
        children: [
          {
            label: "Low carb",
            children: [
              {
                label: "Low carb para principiantes",
                href: "/es/low-carb"
              },
              {
                label: "Todas las guías",
                href: "/es/low-carb/guias"
              },

              {
                label: "Alimentos",
                href: "/es/low-carb/alimentos"
              },
              {
                label: "Guías gráficas",
                href: "/es/guias-graficas"
              },
              {
                label: "Efectos secundarios",
                href: "/es/keto/efectos-secundarios"
              },
              {
                label: "Plan de comidas",
                href: "/es/low-carb/menu-bajo-en-carbohidratos"
              },
              {
                label: "Recetas",
                href: "/es/low-carb/recetas"
              },
              {
                label: "Menús semanales",
                href: "/es/low-carb/menus"
              }
            ]
          },
          {
            label: "Keto",
            children: [
              {
                label: "Keto para principiantes",
                href: "/es/keto"
              },
              {
                label: "Todas las guías",
                href: "/es/keto/guias"
              },
              // {
              //   label: "Alimentos",
              //   href: "/low-carb/keto/foods"
              // },
              {
                label: "Guías gráficas",
                href: "/es/guias-graficas"
              },
              {
                label: "Efectos secundarios",
                href: "/es/keto/efectos-secundarios"
              },
              {
                label: "Plan de comidas",
                href: "/es/keto/menu-cetogenico"
              },
              {
                label: "Recetas",
                href: "/es/keto/recetas-cetogenicas"
              },
              {
                label: "Menús semanales",
                href: "/es/keto/menus"
              }
            ]
          },
          {
            label: "Alta en proteína",
            children: [
              {
                label: "Qué es una dieta alta en proteina",
                href: "/es/alta-en-proteinas"
              },
              {
                label: "Alimentos",
                href: "/es/alta-en-proteinas/alimentos"
              },
              {
                label: "Snacks",
                href: "/es/alta-en-proteinas/snacks"
              },
              {
                label: "Recetas",
                href: "/es/alta-en-proteinas/recetas"
              },
              {
                label: "Menús semanales",
                href: "/es/alta-en-proteinas/menus"
              }
            ]
          },
          {
            label: "Ayuno intermitente",
            href: "/es/ayuno-intermitente"
          },
          {
            label: "Preguntas frecuentes sobre low carb y keto",
            href: "/es/low-carb/preguntas-y-respuestas"
          },
          {
            label: "Política alimentaria de Diet Doctor",
            href: "/es/politica-alimentaria"
          }
        ]
      },
      {
        label: "Adelgazar",
        children: [
          {
            label: "Dieta saludable para adelgazar",
            href: "/es/peso-saludable"
          },
          {
            label: "Cómo bajar de peso",
            href: "/es/bajar-de-peso"
          },
          {
            label: "Programa para adelgazar",
            href: "/es/bajar-de-peso/10-semanas"
          },
          {
            label: "Adelgaza con low-carb",
            href: "/es/keto/beneficios/perder-peso-con-low-carb"
          }
        ]
      },
      {
        label: "Menús",
        children: [
          {
            label: "Mis menús",
            href: "/es/low-carb/menus/mi-planificador",
            onlyPremium: true,
            disabled: (user: IUser) => !isPremium(user)
          },
          {
            label: "Menús personalizados",
            href: "/es/low-carb/menus/personalizacion",
            onlyPremium: true
          },
          {
            label: "Menús temáticos",
            href: "/es/low-carb/menus/todos"
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "Menús low-carb",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Todos los menús low carb",
                href: "/es/low-carb/menus"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Ayuno intermitente",
                href: "/es/low-carb/menus/ayuno-intermitente"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Rápidos y fáciles",
                href: "/es/low-carb/menus/rapidos-y-faciles"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Para toda la familia",
                href: "/es/low-carb/menus/en-familia"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Sin lácteos",
                href: "/es/low-carb/menus/sin-lacteos"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Vegetarianos",
                href: "/es/low-carb/menus/vegetarianos"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Cocina mundial",
                href: "/es/low-carb/menus/cocina-mundial"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Equipo DD",
                href: "/es/low-carb/menus/favoritos-del-equipo-diet-doctor"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Otros",
                href: "/es/low-carb/menus/otros"
              }
            ]
          },
          {
            guard: (user: IUser) => isPremium(user),
            label: "Menús keto",
            children: [
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Todos los menús keto",
                href: "/es/keto/menus"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Ayuno intermitente",
                href: "/es/keto/menus/ayuno-intermitente"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Rápidos y fáciles",
                href: "/es/keto/menus/rapidos-y-faciles"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Para toda la familia",
                href: "/es/keto/menus/en-familia"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Sin lácteos",
                href: "/es/keto/menus/sin-lacteos"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Vegetarianos",
                href: "/es/keto/menus/vegetarianos"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Cocina mundial",
                href: "/es/keto/menus/cocina-mundial"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Equipo DD",
                href: "/es/keto/menus/favoritos-equipo-dd"
              },
              {
                disabled: (user: IUser) => !isPremium(user),
                label: "Otros",
                href: "/es/keto/menus/otros"
              }
            ]
          },
          {
            label: "Menús altos en proteína",
            href: "/es/alta-en-proteinas/menus",
            onlyPremium: true
          },
          {
            label: "Menú Low-carb de prueba",
            href: "/es/low-carb/menu-bajo-en-carbohidratos",
            guard: (user: IUser) => !isPremium(user)
          },
          {
            label: "Menú Keto de prueba",
            href: "/es/keto/menu-cetogenico",
            guard: (user: IUser) => !isPremium(user)
          }
        ]
      },
      {
        label: "Recetas",
        children: [
          {
            label: "Mis favoritas",
            href: "/es/miembro/mis-favoritos",
            onlyPremium: true
          },
          {
            label: "Recetas low-carb",
            href: "/es/low-carb/recetas"
          },
          {
            label: "Recetas keto",
            href: "/es/keto/recetas-cetogenicas"
          },
          {
            label: "Recetas altas en proteína",
            href: "/es/alta-en-proteinas/recetas"
          },
          {
            label: "Colecciones de recetas",
            href: "/es/low-carb/recetas/colecciones"
          },
          {
            label: "Videos de cocina",
            href: "/es/video/cocina"
          }
        ]
      },
      {
        label: "Salud",
        children: [
          {
            label: "Beneficios a la salud",
            href: "/es/salud"
          },
          {
            label: "Corrección de diabetes T2",
            href: "/es/diabetes"
          },
          {
            label: "Normalizar la presión arterial",
            href: "/es/presion-arterial"
          },
          {
            label: "Nutrición",
            href: "/es/nutricion"
          },
          {
            label: "Médicos",
            href: "/es/keto/para-medicos"
          }
        ]
      },
      {
        label: "Aprende más",
        children: [
          {
            label: "Vídeo",
            href: "/es/video"
          },
          {
            label: "Cursos",
            href: "/es/video/cursos"
          },
          {
            label: "Películas",
            href: "/es/video/peliculas"
          },
          // {
          //   label: "Podcast",
          //   href: "/video/podcast"
          // },
          {
            label: "Nuevos vídeos",
            href: "/es/video/nuevo"
          },
          {
            label: "Explora",
            href: "/es/explora-dd-plus"
          }
        ]
      }
    ]
  },
  {
    children: [
      {
        ...freeTrial
      },
      {
        ...login
      }
    ]
  },
  {
    children: [
      {
        label: "Novedades",
        href: "/es/novedades"
      },
      {
        label: "Programas y cursos",
        children: [
          {
            label: "Planificación de comidas",
            href: "/es/low-carb/menus/personalizado"
          },
          {
            label: "Reto keto",
            href: "/es/keto/empezar"
          },
          {
            label: "Programa para adelgazar",
            href: "/es/bajar-de-peso/10-semanas"
          },
          {
            label: "Keto con Kristie",
            href: "/es/video/cursos/come-keto-con-kristie"
          },
          {
            label: "Para médicos",
            href: "/es/keto/para-medicos"
          },
          {
            label: "Curso CME",
            href: "https://www.dietdoctor.com/es/cme"
          },
          {
            label: "Centro de ayuda",
            href: "https://dietdoctor.zendesk.com/hc/es"
          }
        ]
      },
      {
        label: "Historias de éxito",
        href: "/es/historias-de-exito"
      },
      {
        label: "Acerca de",
        children: [
          {
            label: "Acerca de Diet Doctor",
            href: "/es/acerca-de"
          },
          {
            label: "Contacto",
            href: "/es/acerca-de/contacto"
          },
          {
            label: "Equipo",
            href: "/es/acerca-de/equipo-diet-doctor"
          },
          {
            label: "Membresía",
            href: "/es/miembro/acerca-de-membresia"
          },
          {
            label: "La historia",
            href: "/es/acerca-de/la-historia-de-diet-doctor"
          }
        ]
      },
      {
        label: "Centro de ayuda",
        href: "https://dietdoctor.zendesk.com/hc/es"
      }
    ]
  }
];
